import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

interface StyledInlineTableBodyRowProps {
    disabled?: boolean;
}

export const StyledInlineTableBodyRow = styled.tr<StyledInlineTableBodyRowProps>`
    color: ${(props) => (props.disabled ? theme.colors.foreground.disabled : theme.colors.foreground.default)};

    &:hover {
        background-color: ${theme.colors.background.subtle};
    }

    td:first-child {
        border-top-left-radius: ${theme.radii[4]};
        border-bottom-left-radius: ${theme.radii[4]};
    }

    td:last-child {
        border-top-right-radius: ${theme.radii[4]};
        border-bottom-right-radius: ${theme.radii[4]};
    }
`;
